<div class="modal">
  <div class="mask"></div>
  <!-- Modal overlay with continue/cancel actions buttons
    Buttons copy is customizable -->
  <ng-container>
    <div
      [ngClass]="{
        container: modalType === modalOverlayType.continue,
        empty: modalType === modalOverlayType.empty
      }"
    >
      <ng-content></ng-content>
      <div *ngIf="actionButtons && actionButtons.length" class="actions">
        <button
          *ngFor="let button of actionButtons"
          type="button"
          class="button button--small"
          [ngClass]="{
            'button--small': modalType === modalOverlayType.continue,
            'button--big': modalType === modalOverlayType.empty,
            'button--dark':
              modalType === modalOverlayType.continue &&
              button.type === modalContinueActions.continue,
            'button--transparent':
              (modalType === modalOverlayType.continue &&
                button.type === modalContinueActions.cancel) ||
              (modalType === modalOverlayType.empty &&
                button.type === modalContinueActions.continue),
            'link link--light link--semibold link--borderless':
              modalType === modalOverlayType.empty &&
              button.type === modalContinueActions.cancel
          }"
          [disabled]="
            button.type === modalContinueActions.continue &&
            disabledMainActionButton
          "
          (click)="onButtonClick(button.type)"
        >
          {{ button.title }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
